import React, { useMemo } from 'react';
import { useMMDataContext } from '../../../contexts/MMDataContext';

import { KeyMetricData } from 'src/types';
import { useCPULabel } from 'src/features/MM/hooks/useCPULabel';
import { getAggregateLevelData } from 'src/features/MM/utils/getAggregateLevelData';
import { AggregateLevel } from 'src/types';
import { KeyMetricCard } from 'src/components/molecules/KeyMetricCard';
// eslint-disable-next-line no-restricted-imports
import { Icon as ChakraIcon } from '@chakra-ui/react';
import { Tag } from 'lucide-react';
import { calculateTrendFromTimeSeries } from 'src/utils/calculateTrendFromTimeSeries';

type CostPerUnitProps = {
  aggregateLevel: AggregateLevel;
};

export const CostPerUnit: React.FC<CostPerUnitProps> = ({ aggregateLevel }) => {
  const { cpu } = useMMDataContext();

  const label = useCPULabel();

  const keyMetricData: KeyMetricData = useMemo(() => {
    return {
      isLoading: cpu.isLoading,
      isError: cpu.isError,
      name: label,
      isEuro: true,
      summaryValue: cpu.total,
      data: getAggregateLevelData(cpu, aggregateLevel),
    };
  }, [cpu, label, aggregateLevel]);

  const { trend, trendValue } = useMemo(() => {
    return calculateTrendFromTimeSeries(keyMetricData?.data ?? []);
  }, [keyMetricData]);

  return (
    <KeyMetricCard
      title="Cost per unit"
      trend={trend}
      trendValue={trendValue}
      value={keyMetricData.summaryValue}
      isLoading={keyMetricData.isLoading}
      isError={keyMetricData.isError}
      icon={<ChakraIcon as={Tag} boxSize={5} color="gray.500" />}
    />
  );
};
